import {Component, Input, OnInit} from '@angular/core';
import {FileManagerService} from '../../../modules/file-manager/file-manager.service';
import {DocumentDataModel} from '../../../models/document/document-data.model';
import {ITdoFileHandle} from '../../../models/ui/i-tdo-file-handle';
import {DocumentUploadModel} from '../../../models/document/document-upload.model';
import {DocumentClassEnum} from '../../../models/enum/document/document-class.enum';
import {DocumentTypeEnum} from '../../../models/enum/document/document-type.enum';
import {FileHelperService} from '../../../services/file-helper.service';
import {DocumentFileTypeEnum} from '../../../models/enum/document/document-file-type.enum';
import {Globals} from '../../../globals';
import {DocumentGroupCreationModel} from '../../../models/document/document-group-creation.model';
import {OrganizerOpenInImagingModel} from '../../../main-interface/controls/tdo-organizer/models/organizer-open-in-imaging.model';
import {UiService} from '../../../services/ui.service';

@Component({
  selector: 'app-tdo-document-viewer',
  templateUrl: './tdo-document-viewer.component.html',
  styleUrls: ['./tdo-document-viewer.component.scss']
})
export class TdoDocumentViewerComponent implements OnInit {
  @Input() objectId: string;
  @Input() tags: string[] = [];
  @Input() maxPx: number = 0;

  index = 0;

  documents: DocumentDataModel[] = [];

  constructor(public documentService: FileManagerService,
              private globals: Globals,
              private uiService: UiService,
              private fileHelperService: FileHelperService) { }

  ngOnInit(): void {
    this.checkForDocumentImages();
  }

  onFilesDropped(event: ITdoFileHandle[]) {
    event = event.filter(p => p.file.type === 'image/jpeg' || p.file.type === 'image/png');
    const file: File = event[0].file;
    this.uploadDocuments([file]);
  }

  checkForDocumentImages() {
    this.documentService.getDocumentsByTagsAndGroup(this.tags, this.objectId).subscribe((res) => {
    this.documents = res;
    });
  }

  uploadDocuments(files: File[]) {
    /*console.log('File type: ' + files[0].type);
    return;*/
    // this.isUploading = true;

    this.fileHelperService.getDataAndThumbnailFromFile(files[0]).subscribe((mod) => {
      const fileModel = mod;
      const uploadModel = new DocumentUploadModel();
      uploadModel.blob = fileModel.fileDataBlob;
      uploadModel.blobThumbnail = fileModel.thumbnailDataBlob;
      uploadModel.docClassId = DocumentClassEnum.Original;
      uploadModel.docTypeId = DocumentTypeEnum.MedicalImaging;
      uploadModel.hasAnnotation = false;
      uploadModel.docTagIds = this.tags;

      switch (fileModel.fileMimeType) {
        case FileHelperService.MIME_JPG:
        case FileHelperService.MIME_PNG:
          uploadModel.docFileTypeId = DocumentFileTypeEnum.JPG;
          break;
      }

      uploadModel.patientId = this.globals.currentPatientId;
      uploadModel.patientCaseId = this.globals.currentPatientCaseId;

      this.documentService.uploadDocuments([uploadModel]).subscribe((response) => {
        const res = response.documents[0];
        this.documentService.addMultiDocumentsTags([res.DocumentID], this.tags).subscribe((responseAddTag) => {
          const cmodel = new DocumentGroupCreationModel();
          cmodel.documentIds = [response.documents[0].DocumentID];
          cmodel.ObjectId = this.objectId;
          cmodel.PatientId = this.globals.currentPatientId;
          this.documentService.createDocumentGroup(cmodel).subscribe((res3) => {
            this.checkForDocumentImages();
          });
        });
      });
    });
  }

  previous() {
    this.index--;
  }

  next() {
    this.index++;
  }

  openCurrentInDraw() {
    const openInImagingModel = new OrganizerOpenInImagingModel();
    openInImagingModel.documents = [this.documents[this.index]];
    localStorage.setItem('open-in-imaging', JSON.stringify(openInImagingModel));
    this.uiService.openImagingWindow();
  }

  openAllInDraw() {
    const openInImagingModel = new OrganizerOpenInImagingModel();
    openInImagingModel.documents = this.documents;
    localStorage.setItem('open-in-imaging', JSON.stringify(openInImagingModel));
    this.uiService.openImagingWindow();
  }
}
